<template>
    <h2 class="title">User List</h2>
    <p class="description">
      Check the box next to a user to mark them as <strong>soft banned</strong>.
    </p>

    <input
      v-if="users.length"
      type="text"
      placeholder="Search users..."
      v-model="searchQuery"
    />

    <ul v-if="filteredUsers.length" class="user-list">
      <li v-for="user in filteredUsers" :key="user.id" class="user-item">
        <label class="user-checkbox-label">
          <input
            type="checkbox"
            v-model="user.is_soft_banned"
            @change="onCheckboxToggle(user)"
          />
          <div>
            {{ user.first_name }} {{ user.last_name }}
            <br />
            {{ user.email }}
            <br />
            {{ user.phone }}
            <div class="user-status" :class="{ banned: user.is_soft_banned }">
              Status:
              <strong>{{
                user.is_soft_banned ? "SOFT BANNED" : "Active"
              }}</strong>
            </div>
          </div>
        </label>
      </li>
    </ul>

    <div v-else>
      <p>No users found for this dealer.</p>
    </div>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  users: {
    type: Array,
    required: true,
  },
});
const searchQuery = ref("");

const filteredUsers = computed(() => {
  const query = searchQuery.value.trim().toLowerCase();
  if (!query) return props.users;
  return props.users.filter((u) =>
    `${u.first_name} ${u.last_name} ${u.email} ${u.phone}`
      .toLowerCase()
      .includes(query)
  );
});

const emit = defineEmits(["ban-toggle"]);

function onCheckboxToggle(user) {
  emit("ban-toggle", { id: user.id, is_soft_banned: user.is_soft_banned });
}
</script>
<style lang="css" scoped>

.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}
.description {
  margin-bottom: 1rem;
  font-size: 0.95rem;
  color: var(--fg0);
  font-style: italic;
}
.user-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.user-item {
  display: flex;
  flex-direction: row;
  padding: 8px 0;
  border-bottom: 1px solid var(--fg0);
}
.user-checkbox-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.user-status {
  margin-top: 4px;
  font-size: 0.85rem;
  color: green;
}

.user-status.banned {
  color: #b94a48;
  font-weight: bold;
}
</style>
